/**
 * Shared authenticated HTTP client (Épico 39 / #13).
 * Prefer this over raw fetch + authHeaders at call sites.
 */
import { apiUrl } from './api';
import { authFetch, authHeaders } from './auth';

export { apiUrl, authFetch, authHeaders };

export function apiRequest(path, options = {}) {
  const { headers, ...rest } = options;
  return authFetch(apiUrl(path), {
    ...rest,
    headers: authHeaders(headers || {}),
  });
}

export function apiGet(path, options = {}) {
  return apiRequest(path, { ...options, method: options.method || 'GET' });
}

export function apiPost(path, body, options = {}) {
  const headers = { 'Content-Type': 'application/json', ...(options.headers || {}) };
  return apiRequest(path, {
    ...options,
    method: 'POST',
    headers,
    body: body != null && typeof body !== 'string' ? JSON.stringify(body) : body,
  });
}

export function apiDelete(path, options = {}) {
  return apiRequest(path, { ...options, method: 'DELETE' });
}
